module.exports = __webpack_public_path__ + "img/16.df41d192.webp";